import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dialogue",
  "use": "dialogue-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"dialogue\"><path fill-rule=\"evenodd\" d=\"M19 6v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1h-2Zm-2-3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1V3Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol